import "./PremiumPointTransfer.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetSpecificUserPremium_PlusAmountQuery,
  useGetTotalPointsQuery,
  useUpdatePremiumUsingPointMutation,
} from "../../../../services/userApi";
import { useGetAllPremiumCouponQuery } from "../../../../services/addMoneyApi";
import { Notification } from "../../../../components/ToastNotification";
import { useState } from "react";
import ViewMore from "./ViewMore";
import BottomSheetModal from "./BottomSheetModal";
import { AiOutlineCloseCircle } from "react-icons/ai";

export default function PremiumPointTransfer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { amount } = location.state || {};

  const { data: getTotalPoints } = useGetTotalPointsQuery();
  const { data: premiumplusamount } = useGetSpecificUserPremium_PlusAmountQuery();
  const fetchedAmount = premiumplusamount?.new_price_premium || premiumplusamount?.old_price_premium;
  const effectiveAmount = fetchedAmount !== undefined && fetchedAmount !== null ? fetchedAmount : (amount || 0);

  const isPremiumPlus = false;
  const [updatePremiumUsingPoint] = useUpdatePremiumUsingPointMutation();
  const {
    data: getcoupon,
    isLoading: loading,
    isError,
  } = useGetAllPremiumCouponQuery({});

  const coupons = getcoupon?.coupons || [];

  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [visible, setVisible] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Slider navigation
  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredCoupons.length - 1 : prev - 1
    );
  };
  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === filteredCoupons.length - 1 ? 0 : prev + 1
    );
  };

  // Filtered coupons (Premium)
  const filteredCoupons = coupons.filter(
    (coupon) => !coupon.isHide && coupon.couponFor === "Premium"
  );

  // Points calculation
  const basePoints = effectiveAmount * 100;
  const discountedPoints = appliedCoupon
    ? basePoints - appliedCoupon.value * 100
    : basePoints;
  let Disabled = getTotalPoints?.currentPoint < discountedPoints;

  // Buy handler
  const handleBuy = async () => {
    try {
      const result = await updatePremiumUsingPoint({
        amount: amount,
        isPremiumPlus: false,
        appliedCoupon: appliedCoupon?.couponId || null,
      }).unwrap();

      if (result?.success) {
        Notification(result?.msg, "success");
      } else {
        Notification(result?.msg, "error");
      }

      setShowModal(false);
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <div className="premium-container">
      {/* Premium Card */}
      <div className="premium-card">
        <div className="inputWrapper">
          <div className="premium-badge">Premium</div>
          <p className="premium-subtitle">
            Upgrade your account to Premium
          </p>

          {/* Cost Summary - Only show if a coupon is applied */}
          {appliedCoupon && (
            // <div className="costSummary">
            //   <div className="costRow">
            //     <div className="costLabel">Original Cost</div>
            //     <div className="costValue">{basePoints} points</div>
            //   </div>
            //   <div className="costRow">
            //     <div className="costLabel">Discount</div>
            //     <div className="costValue, styles.discount]">
            //       -{appliedCoupon.value} points
            //     </div>
            //   </div>
            //   <div className="styles.costRow, styles.totalRow">
            //     <div className="totalLabel">Final Cost</div>
            //     <div className="totalValue">{discountedPoints} points</div>
            //   </div>
            // </div>
            <div className="costSummary">
              <div className="costRow">
                <span className="costLabel">Original Cost</span>
                <span className="costValue">{basePoints} points</span>
              </div>
              <div className="costRow">
                <span className="costLabel">Discount</span>
                <span className="costValue discount">
                  -{appliedCoupon.value * 100} points
                </span>
              </div>
              <div className="costRow totalRow">
                <span className="totalLabel">Final Cost</span>
                <span className="totalValue">{discountedPoints} points</span>
              </div>
            </div>
          )}

          {/* Points Required */}

          <div className="input-group">
            <label>Final Points Required</label>
            <input
              style={
                Disabled ? { border: "1px solid red", borderRadius: 5 } : {}
              }
              type="number"
              value={discountedPoints}
              readOnly
            />
            <span
              style={
                Disabled
                  ? { color: "red", fontSize: "12px" }
                  : { display: "none" }
              }
            >
              Insufficient points
            </span>
          </div>

          {/* Available Points */}
          <div className="points-box">
            <p>
              Your Available Points: {getTotalPoints?.currentPoint}{" "}
              <img
                style={{ width: "14px", height: "14px" }}
                src="https://i.postimg.cc/1zKkRz5N/point.png"
                alt="points"
              />
            </p>
          </div>

          {/* Buy Button */}
          <button
            onClick={() => setShowModal(true)}
            disabled={Disabled}
            className="buy-btn"
          >
            🚀 Buy Premium
          </button>
        </div>

        {/* Applied Coupon */}
        {appliedCoupon ? (
          <div className="applied-coupon-box">
            <div className="remove-applied-coupon">
              <button
                className="remove-coupon"
                onClick={() => setAppliedCoupon(null)}
              >
                <AiOutlineCloseCircle size={18} color="black" />
              </button>
            </div>
            <div className="applied-coupon-box-inside">
              <div className="info">
                <span className="icon">✓</span>
                <div className="textContainer">
                  <span className="title">Coupon code applied</span>
                  <span className="subtitleText">
                    {appliedCoupon?.shortDescription}! - Unlock
                  </span>
                </div>
                <button className="couponTextButton">
                  <span className="couponTextButtonText">
                    {appliedCoupon.couponText}
                  </span>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <span
            style={{
              alignSelf: "center",
              marginLeft: "60px",
              marginTop: "10px",
              alignItems: "center",
            }}
          >
            Got a coupon code?{" "}
            <span
              onClick={() => {
                setVisible(true);
              }}
              style={{ color: "purple", cursor: "pointer" }}
            >
              Apply
            </span>
          </span>
        )}

        <div className="couponBox">
          {/* Coupon Slider */}
          {!loading && (
            <div className="coupon-section">
              {isError || filteredCoupons.length === 0 ? (
                <p style={{ alignSelf: "flex-start", marginLeft: "22px" }}>
                  No Coupons Available
                </p>
              ) : (
                <>
                  <div className="slider-wrapper">
                    <button className="nav-btn prev" onClick={handlePrev}>
                      &#10094;
                    </button>

                    <div
                      className="coupon-slider"
                      style={{
                        transform: `translateX(-${currentIndex * 100}%)`,
                      }}
                    >
                      {filteredCoupons.map((coupon) => (
                        <div key={coupon._id} className="coupon-card-container">
                          <div
                            className={` coupon-card ${appliedCoupon?.couponId === coupon.couponId
                              ? "coupon-card-applied"
                              : ""
                              }`}
                          >
                            <div className="coupon-content">
                              <span>
                                <span
                                  className="coupon-code"
                                  style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 600,
                                  }}
                                >
                                  {coupon.couponText}
                                </span>
                              </span>
                              <button
                                onClick={() => setAppliedCoupon(coupon)}
                                className={`apply-btn ${appliedCoupon?.couponId === coupon.couponId
                                  ? "applied"
                                  : ""
                                  }`}
                                disabled={
                                  appliedCoupon?.couponId === coupon.couponId
                                }
                              >
                                {appliedCoupon?.couponId === coupon.couponId ? (
                                  <strong
                                    style={{
                                      backgroundColor: "#28a745",
                                      // border: "1px solid gray",
                                    }}
                                  >
                                    Applied
                                  </strong>
                                ) : (
                                  <strong>APPLY</strong>
                                )}
                              </button>
                            </div>

                            <div className="DescriptionContainer">
                              <p className="coupon-shortDescription">
                                {coupon.title}
                              </p>
                              <p className="coupon-description">
                                Get {coupon.value * 100} Points OFF
                              </p>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpen(true);
                                  setSelectedCoupon(coupon);
                                }}
                                className={`ViewMore ${appliedCoupon?.couponId === coupon.couponId
                                  ? "ViewMore-applied"
                                  : ""
                                  }`}
                              >
                                View More
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <button className="nav-btn next" onClick={handleNext}>
                      &#10095;
                    </button>
                  </div>

                  <div className="dot-container">
                    {filteredCoupons.map((_, idx) => (
                      <span
                        key={idx}
                        className={`dot ${idx === currentIndex ? "active" : ""
                          }`}
                        onClick={() => setCurrentIndex(idx)}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <ViewMore
        open={open}
        setOpen={setOpen}
        coupon={selectedCoupon}
        paymentType={"Point"}
        setSelectedCoupon={setSelectedCoupon}
        appliedCoupon={appliedCoupon}
        setAppliedCoupon={setAppliedCoupon}
      />
      <BottomSheetModal
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        allCoupons={coupons}
        setAppliedCoupon={setAppliedCoupon}
        isPremiumPlus={false}
      />

      {/* Confirmation Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Confirm Purchase</h3>
            <p>
              Are you sure you want to buy Premium for{" "}
              {discountedPoints} points?
            </p>
            <div className="modal-buttons">
              <button
                className="modal-btn cancel"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="modal-btn confirm" onClick={handleBuy}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
